// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import i18n from '@/i18n'
import './icons' // icon
import './permission'
// vxe-table
import './plugins/vxe-table/vxe-ui.js'
import './assets/styles/vxe-table/index.scss'

import pluginsCommon from './plugins/index.js'

import './assets/styles/theme/index.css'
import './assets/styles/index.scss'
import './utils/drag-resize';

Vue.use(pluginsCommon)

Vue.mixin({
  // data() {
  //   return {
  //     // 访问sap接口需要的登录用户信息
  //     sap_user_bp: '0081000010',
  //     sap_role: 'WLYALL'
  //   }
  // },
  methods: {
    vxeShowCustom(xTable) {
      this.$refs[xTable].$refs.xToolbar.showCustom()
    }
  }
})
/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   store,
//   components: { App },
//   template: "<App/>"
// });
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js